import React from "react";
import { Modal } from "react-bootstrap";

const TrailerModal = ({ show, trailerUrl, handleClose }) => {
  const isMobile = window.innerWidth < 768;

  return (
    <Modal show={show} onHide={handleClose} fullscreen={isMobile} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Watch Trailer</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        {trailerUrl && (
          <iframe
            width="100%"
            height="100%"
            style={{ minHeight: "50vh", border: "none" }}
            src={trailerUrl}
            title="Movie Trailer"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default TrailerModal;
